<template>
  <v-container>
    <v-row v-if="!firstError">
      <v-col>
        <div class="py-5">
          <div class="d-flex justify-space-between">
            <v-breadcrumbs :items="path">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <a href="" @click.prevent="back(item)">{{ item.Name }}</a>
              </template>
            </v-breadcrumbs>
            <!-- <label
              class="btn btn--upload tip__holder"
              :class="{ 'btn--disabled': disabled }"
            >
              <input type="file" @change="upload" :disabled="disabled">
              <img src="/images/upload.svg" alt="Upload">
              <span class="pl-2">Upload file</span>

              <div class="tip__item">
                <span>Max file size 50 mb</span>
              </div>
            </label> -->
          </div>
        </div>
        <v-simple-table>
          <template>
            <thead>
              <tr>
                <th v-for="field in fields" :key="field.text">{{ field.text }}</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="folder in folders"
                :key="folder.FileName"
                @click="next(folder)"
                class="cursor--pointer"
              >
                <td v-for="field in fields" :key="field.text">
                  <div class="d-flex align-center">
                    <v-icon color="primary" class="icon" v-if="field.value === 'FileName'">
                      $vuetify.icons.folderIcon
                    </v-icon>
                    <span class="d-block ml-4 text-wrap">{{ _.get(folder, field.value) | datetime('-') }}</span>
                  </div>
                </td>
                <td>-</td>
              </tr>
              <tr v-for="file in files" :key="file.Name">
                <td
                  v-for="field in fields"
                  :key="field.text"
                >
                  <div class="d-flex align-center">
                    <v-icon :color="iconColor(file)" class="icon" v-if="field.value === 'FileName'">
                      {{ iconFile(file) }}
                    </v-icon>
                    <span class="d-block ml-4 text-wrap">
                      {{ _.get(file, field.value) || _.get(file, field.fall) | datetime('-') }}
                    </span>
                  </div>
                </td>
                <td>
                  <v-btn
                    @click="download(file)"
                    :disabled="isDownloading(file)"
                    :loading="isDownloading(file)"
                    icon
                  >
                    <v-icon>mdi-cloud-download-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="py-5 text-center" v-if="isLoading">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <p
      class="text-center py-10 primary--text"
      v-if="errorBad"
      v-translate="'docs.errors.400'"
    >Error</p>
    <p
      class="text-center py-10 primary--text"
      v-if="errorForbid"
      v-translate="'docs.errors.403'"
    >Error</p>
    <!-- <v-dialog :value="_.keys(notify).length" max-width="280">
      <v-card>
        <v-card-title>{{ notify.title }}</v-card-title>
        <v-card-text>{{ notify.message }}</v-card-text>
        <v-card-text v-if="notify.loading" class="py-5 text-center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-card-text>
        <v-card-actions v-if="!notify.loading">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { uid } from '@/utils';
import store from '@/store';
import { Scope, Docs } from '@/api';

export default {
  name: 'app-docs',
  async beforeRouteEnter(to, from, next) {
    const { data: scope } = await Scope.fetch({ name: to.params.scope });
    // const { root } = to.query;
    store.commit('SET_SCOPE', scope);
    store.commit('START_LOADING');

    try {
      // const { data: docs } = await Docs.exec({
      //   email: store.state.User.email,
      //   type: 0,
      //   value: scope.name + (root ? `/${root}` : ''),
      // }, { params: { bypass } });
      const { data: docs } = await Docs.getLibrary({ path: to.params.scope });

      store.commit('END_LOADING');
      next((vm) => {
        /* eslint-disable */
        // vm.permissions = permissions;
        vm.files = docs.files;
        vm.folders = docs.folders;
        vm.path.push(docs.current);
        // vm.path.push(scope.name, ...(root || '').split('/').filter(Boolean));
        // vm.pathLimit = vm.path.length;
        /* eslint-enable */
      });
    } catch (e) {
      store.commit('END_LOADING');
      next((vm) => {
        /* eslint-disable */
        if (e.response) vm.errors.push(e.response);
        /* eslint-enable */
      });
    }
  },
  data() {
    return {
      wordRegex: /.doc|.docx|.DOC|.DOCX|.docm|.dot|.dotx/,
      excelRegex: /.xlsb|.xlsx|.xlsm|.xls|.xltx|.xltm|.xlt|.xml|.xlam|.xla|.xlw/,
      powerPointRegex: /.pptx|.pptm|.ppt|.potx|.potm|.pot|.ppsx|.ppsm|.pps|.ppam|.ppa/,
      path: [],
      files: [],
      folders: [],
      disabled: false,
      downloading: '',
      isLoading: false,
      update: 0,
      // path: [],
      // pathLimit: 0,
      // notify: {},
      // permissions: {},
      errors: [],
      fields: [
        {
          text: 'Name',
          value: 'FileName',
        },
        {
          text: 'Modified',
          value: 'Result.LastModifiedDateTime',
        },
        {
          text: 'Author',
          value: 'Result.CreatedBy.User.DisplayName',
        },
      ],
    };
  },
  watch: {
    update: {
      immediate: true,
      handler() {
        setTimeout(() => {
          /* eslint-disable */
          if (parent.window.document.querySelector('iframe')) {
            parent.window.document.querySelector('iframe').height = 0;
            parent.postMessage(
              window.document.body.offsetHeight,
              window.location.origin,
            );
          }
          /* eslint-enable */
        });
      },
    },
  },
  computed: {
    ...mapState({
      scope: 'Scope',
    }),
    driveId() {
      return this.path[0]?.Id;
    },
    // bypass() {
    //   return this.$route.query.bypass;
    // },
    // breadcrumbs() {
    //   return this.path.map(p => ({ text: p }));
    // },
    // sortedFolders() {
    //   return this.folders.slice().sort((a, b) => (a.Name > b.Name ? 1 : -1));
    // },
    // sortedFiles() {
    //   return this.files.slice().sort((a, b) => (a.Name > b.Name ? 1 : -1));
    // },
    // canUpload() {
    //   return this.permissions ? +this.permissions.High > 400 : false;
    // },
    // root() {
    //   return this.$route.query.root;
    // },
    firstError() {
      return this.errors.slice().shift();
    },
    errorBad() {
      return window._.get(this.firstError, 'status') === 400;
    },
    errorForbid() {
      return window._.get(this.firstError, 'status') === 403;
    },
  },
  methods: {
    iconColor(document) {
      switch (true) {
        case /.pdf/.test(document.Name):
          return 'red';
        case this.wordRegex.test(document.Name):
          return 'blue darken-2';
        case this.excelRegex.test(document.Name):
          return 'green darken-2';
        case this.powerPointRegex.test(document.Name):
          return 'orange darken-4';
        default:
          return 'blue lighten-2';
      }
    },
    iconFile(document) {
      switch (true) {
        case /.pdf/.test(document.Name):
          return 'mdi-file-pdf';
        case this.wordRegex.test(document.Name):
          return 'mdi-file-word';
        case this.excelRegex.test(document.Name):
          return 'mdi-file-excel';
        case this.powerPointRegex.test(document.Name):
          return 'mdi-file-powerpoint';
        default:
          return '$vuetify.icons.fileIcon';
      }
    },
    async navigate(folder) {
      this.clear();

      try {
        const { data: docs } = await Docs.getLibraryChildren({ driveId: this.driveId, path: folder.Id });

        this.files = docs.files;
        this.folders = docs.folders;
        this.path.push(docs.current);
        this.update = uid();
      } catch (e) {
        if (e.response) this.errors.push(e.response);
      }
    },
    async next(folder) {
      this.isLoading = true;
      await this.navigate(folder);
      this.isLoading = false;
    },
    async back(folder) {
      this.isLoading = true;

      if (folder.Id === this.driveId) {
        this.clear();
        const { data: docs } = await Docs.getLibrary({ path: folder.Name });

        this.files = docs.files;
        this.folders = docs.folders;
        this.path = [docs.current];
        this.update = uid();
      } else {
        this.navigate(folder);
        this.path = this.path.slice(0, this.path.indexOf(folder) + 1);
        this.path.pop();
      }

      this.isLoading = false;
    },
    clear() {
      this.files = [];
      this.folders = [];
    },
  //   close() {
  //     this.notify = {};
  //   },
    async download(file) {
      this.downloading = file.FileName;
      this.disabled = true;
      const anchor = window.document.createElement('a');

      try {
        const { data } = await Docs.downloadFile({ driveId: this.driveId, path: file.Id });

        anchor.href = window.URL.createObjectURL(data);
        anchor.download = file.FileName;
        anchor.click();
        this.downloading = '';
      } finally {
        this.disabled = false;
      }
    },
    async upload(e) {
      const { files } = e.target;
      const f = new FormData();
      let error = false;
      this.disabled = true;
      this.notify = {};

      f.append('email', store.state.User.email);
      f.append('value', this.path.join('/'));

      Array.from(files).map((file) => {
        if ((file.size / 1024 / 1000).toFixed(2) > 50) {
          this.notify.title = 'Something went wrong';
          this.notify.message = 'The file cannot be more than 50 mb';
          error = true;
        }

        f.append('file', file);
        return file;
      });

      if (error) {
        this.disabled = false;
        return false;
      }

      try {
        this.notify.title = 'Uploading file';
        this.notify.message = 'This process could take some minutes depending of the file size';
        this.notify.loading = true;
        e.target.value = null;
        await Docs.file(f);
        await this.surf();
      } finally {
        this.notify.message = 'Done';
        this.notify.loading = false;
        this.disabled = false;
      }

      return true;
    },
    isDownloading(file) {
      return file.FileName === this.downloading;
    },
  },
};
</script>
